module.exports = __webpack_public_path__ + "img/headlogo.b889cb48.png";